var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1926 1.60264C16.0558 -0.534235 12.5792 -0.534235 10.4423 1.60264L2.28204 9.76284C2.0302 10.0147 2.0302 10.4227 2.28204 10.6745C2.53388 10.9263 2.94187 10.9263 3.19371 10.6745L11.3539 2.51431C12.9379 0.931515 15.6969 0.931515 17.2809 2.51431C18.9147 4.14811 18.9147 6.80693 17.2809 8.44073L5.8863 19.9637C4.91168 20.9383 3.21364 20.9383 2.23907 19.9637C1.2336 18.9582 1.2336 17.3225 2.23907 16.317L13.1779 5.24927C13.543 4.88412 14.1802 4.88412 14.5454 5.24927C14.9225 5.62637 14.9225 6.24026 14.5454 6.6174L4.06301 17.2287C3.84558 17.4461 3.84558 17.9229 4.06301 18.1403C4.31485 18.3922 4.72283 18.3922 4.97467 18.1403L15.457 7.52902C16.3372 6.64881 16.3372 5.21778 15.457 4.3376C14.6045 3.48515 13.1174 3.48639 12.2662 4.3376L1.3274 15.4053C-0.169029 16.9018 -0.169029 19.3788 1.3274 20.8753C2.05838 21.6063 3.02982 22 4.06296 22C5.0961 22 6.06763 21.6063 6.79797 20.8753L18.1926 9.35236C20.3295 7.21548 20.3295 3.73948 18.1926 1.60264Z",
    fill: "#4B9BF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachFile);
export default __webpack_public_path__ + "static/media/attach-file.49ca5b42a6f58b05f51f7e04320dc3e1.svg";
export { ForwardRef as ReactComponent };